export default "__VITE_ASSET__CDzN0JBJ__"